import {Tag} from '@wandb/weave/components/Tag/Tag';
import {TailwindContents} from '@wandb/weave/components/Tailwind';
import React from 'react';

import {trackObservabilityTagClick} from '../../services/analytics/observabilityEvents';
import {useIssuesContext} from '../../state/issues/IssuesContext';
import {WBTableRowWithRunSetInfo} from '../../util/tablecols';
import {Skeleton} from '../Skeleton';
import {useMaybeWorkspaceDrawerContext} from '../WorkspaceDrawer/WorkspaceDrawerContextProvider';
import {useRunIssues} from './hooks/useRunIssues';

type RunSelectorIssuesCellProps = {
  row: WBTableRowWithRunSetInfo;
  entityName: string;
  projectName: string;
};

export function RunSelectorIssuesCell({
  row,
  entityName,
  projectName,
}: RunSelectorIssuesCellProps) {
  const workspaceDrawerContext = useMaybeWorkspaceDrawerContext();
  const {addIssues, updateErrorIssue, setActiveRun} = useIssuesContext();

  const {
    data: nodeAlertsHistory = [],
    error,
    loading,
  } = useRunIssues({
    entityName,
    projectName,
    runName: row.name,
  });

  function handleClick() {
    const tagType = error
      ? 'error'
      : nodeAlertsHistory.length > 0
      ? 'alert'
      : 'success';

    // in a report there's no current functionality for interacting with an issues cell in the table
    // The issues column should be turned off in a report higher up, but this is a safety check to keep
    // the cell from erroring if that changes
    if (
      workspaceDrawerContext &&
      workspaceDrawerContext.toggleWorkspaceDrawer
    ) {
      trackObservabilityTagClick({
        action: 'Click issue tag',
        issuesCount: error ? 0 : nodeAlertsHistory.length,
        tagType,
        entityName,
        projectName,
      });
      setActiveRun(row);
      workspaceDrawerContext?.toggleWorkspaceDrawer('run-issues');
      addIssues(error ? [] : nodeAlertsHistory); // Convert to internal type?
    }

    if (error) {
      updateErrorIssue(true);
    }
  }

  if (loading) {
    return (
      <TailwindContents>
        <Skeleton className="rounded-sm opacity-60" height={22} width={35} />
      </TailwindContents>
    );
  }

  return (
    <TailwindContents>
      <div onClick={handleClick} className="flex  cursor-pointer">
        {error ? (
          <Tag showIcon iconName="warning" label="?" color="moon" />
        ) : (
          <Tag
            showIcon
            iconName="warning"
            label={String(nodeAlertsHistory.length ?? 0)}
            color={(nodeAlertsHistory.length ?? 0) > 0 ? 'red' : 'green'}
          />
        )}
      </div>
    </TailwindContents>
  );
}
